<template>
  <section v-if="!isRegDone" class="form-section">
    <div v-if="!isO2o || isDonate" class="form-section__head">
     <h3>개인정보 수집 및 이용 동의</h3>
    </div>
    <div>

     <div v-if="!isO2o" class="agree-box">
        <ol class="list">
          <li class="list__item">
            <p>
              개인정보 수집∙이용목적
            </p>
            <p class="list__item-line">
              <i>-</i>중고폰 판매에 따른 대금 지급
            </p>
          </li>
          <li class="list__item">
            <p>
              수집하는 개인정보 항목
            </p>
            <p class="list__item-line">
              <i>-</i>이름, 은행명, 계좌번호
            </p>
          </li>
          <li class="list__item">
            <p>
              개인정보 <b>보유∙이용기간</b>
            </p>
            <p class="list__item-line">
              <b><i>-</i>거래완료 후 5년</b> <br>
              (단, 법령에 따라 정한 경우에는 해당기간까지)
            </p>
          </li>
          <li class="list__item">
            <p>
              개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의 거부 시 서비스 이용이 제한됩니다.
            </p>
          </li>
        </ol>
      </div>
      <div v-if="!isO2o" class="check-wrap row agrm-form-input-area">
        <DxCheckBox
          text="개인정보 수집 및 이용 동의"
          v-model="agrms.allAgrm"
        />
        <span class="font-red">(필수)</span>
      </div>
      <div  v-if="isDonate" class="agree-box" style="margin-top: 30px;">
        <ol class="list">
          <h4 class="title">[고유식별번호 수집에 대한 동의]</h4>
          <li class="list__item">
            <p>
              개인정보 수집∙이용목적
            </p>
            <p class="list__item-line">
              <i>-</i>연말정산 처리(기부금 영수증 발급)
            </p>
          </li>
          <li class="list__item">
            <p>
              수집하는 개인정보 항목
            </p>
            <p class="list__item-line">
              <i>-</i>이름,주민등록번호
            </p>
          </li>
          <li class="list__item">
            <p>
              기명 기부시 연말정산 처리의 목적으로 주민등록번호를 처리하고 있습니다.
            </p>
            <p class="list__item-line">
              <i>※</i>소득세법 제160조의3, 동법 시행령 제208조의3, 법 인세법 제112조의2, 동법 시행령 제155조의2에 의거하여 수집
            </p>
          </li>
          <li class="list__item">
           <p>
              개인정보 <b>보유∙이용기간</b>
            </p>
            <p class="list__item-line">
              <b><i>-</i>거래완료 후 5년</b> <br>
              (단, 법령에 따라 정한 경우에는 해당기간까지)
            </p>
          </li>
          <li class="list__item">
            <p>
              개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의 거부 시 서비스 이용이 제한됩니다.
            </p>
          </li>
        </ol>
      </div>
      <div v-if="isDonate" class="check-wrap row agrm-form-input-area">
        <DxCheckBox
          text="고유식별번호 수집에 대한 동의"
          v-model="agrms.dntnAgrm"
        />
        <span class="font-red">(필수)</span>
      </div>
      
       <div  v-if="isDonate" class="agree-box" style="margin-top: 30px;">
        <ol class="list">
          <h4 class="title">[개인정보 제3자 제공 동의]</h4>
          <li class="list__item">
            <p>
              개인정보를 제공 받는 자
            </p>
            <p class="list__item-line">
              <i>-</i>세이브더칠드런
            </p>
          </li>
          <li class="list__item">
            <p>
              제공받는 자의 이용 목적
            </p>
            <p class="list__item-line">
              <i>-</i>세액공제용 기부금 영수증 발급
            </p>
          </li>
          <li class="list__item">
            <p>
              제공하는 개인정보 항목
            </p>
            <p class="list__item-line">
              <i>-</i>이름, 주민등록번호
            </p>
          </li>
          <li class="list__item">
            <p>
              보유 및 이용 기간
            </p>
            <p class="list__item-line">
              <i>-</i><b>기부금영수증 발급 및 법적 의무 보유기간(5년)</b><br/><b>완료 시까지</b>
            </p>
          </li>
          <li class="list__item">
            <p>
              본 동의를 거부할 권리가 있으며, 동의 거부 시 기명 기부 서비스 이용이 제한되오니 무기명 기부 신청바랍니다.
            </p>
          </li>
        </ol>
      </div>
      <div v-if="isDonate" class="check-wrap row agrm-form-input-area">
        <DxCheckBox
          text="개인정보 제3자 제공 동의"
          v-model="agrms.dntnAgrm2"
        />
        <span class="font-red">(필수)</span>
      </div>
      
	  <div v-if="isEtland" class="agree-box" style="margin-top: 30px;">
        <h4 class="title">[개인정보 제3자 제공 동의]</h4>
        <ol class="list">
          <li class="list__item">
            <p>
              개인정보를 제공 받는자
            </p>
            <p class="list__item-line">
              <i>-</i>개인정보 제공자: (주)에스와이에스리테일
            </p>
          </li>
          <li class="list__item">
            <p>
              제공받는 자의 이용 목적
            </p>
            <p class="list__item-line">
              <i>-</i>전자랜드 포인트 적립 및 본인 확인용
            </p>
            <p class="list__item-line">
              <i>-</i>마일리지 사용 및 소멸, 마일리지 사용 후 제품 취소 등 확인 목적
            </p>
          </li>
          <li class="list__item">
            <p>
              제공한 개인정보의 항목
            </p>
            <p class="list__item-line">
              <i>-</i>성명, 전화번호
            </p>
          </li>
          <li class="list__item">
            <p>
              제공받는 자의 보유 및 이용기간
            </p>
            <p class="list__item-line">
              <i>-</i>개인정보 제공 <b>동의 후 1개월</b>
            </p>
          </li>
        </ol>
      </div>
       <div v-if="isEtland" class="check-wrap row agrm-form-input-area" style="display:inline;">
        <DxCheckBox
          v-model="agrms.etlandAgrm"
          @valueChanged="handleChocAgrm"
        />
        <span style= "margin-left:0.5%; font-weight:600;">전자랜드 포인트 적립을 위한</span>
        <br/>
        <span style= "margin-left:6.8%; font-weight:600;">개인정보 제3자 제공 동의</span>
        <span class="color-gray-500" style= "font-weight:600;">(선택)</span>
        <br/>
      </div>
      <div v-if="!isO2o" class="agree-box" style="margin-top: 30px;">
        <h4 class="title">[광고 및 마케팅 수신 동의]</h4>
        <ol class="list">
          <li class="list__item no-bullet">
            <p>
              “민팃”과 관련하여, 본인의 개인정보를 민팃 주식회사가 다음과 같이 본인에게 <u class="color-red-300 weightSB">전자적 전송매체를 통해 광고 및 마케팅 목적으로 전송하는 것에 동의합니다.</u>
            </p>
          </li>
          <li class="table-box" style="margin:6px 0 14px">
            <table>
              <thead>
                <tr>
                  <th>수집/이용 목적</th>
                  <th>수집 항목</th>
                  <th>개인정보 보유 <br> 및 이용 기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width:38%;">민팃 광고 메세지<br/>(알림톡, 문자, <br/>앱 푸시 등)발신</td>
                  <td style="width:31%;">통신사, 이름,<br/> 생년월일, 성별,<br/> 휴대폰 번호</td>
                  <td style="width:31%;"><u class="color-red-300 weightSB">거래 완료 후 <br/>부터 5년 또는 <br/>동의 철회 시</u></td>
                </tr>
              </tbody>
            </table>
          </li>
          <li class="list__item bullet-point">
            <p>
              이 내용은 광고 및 마케팅 수신 동의입니다. 동의를 거부하실 권리가 있으며, 동의하지 않아도 “민팃”을 이용하실 수 있습니다.
            </p>
          </li>
        </ol>
      </div>
      <div v-if="!isO2o" class="check-wrap row agrm-form-input-area">
        <DxCheckBox
          text="광고 및 마케팅 수신 동의"
          v-model="agrms.chocAgrm"
          @valueChanged="handleChocAgrm"
        />
        <span class="color-gray-500" style="display: flex; justify-content: center; align-items: center; font-weight:600;">(선택)</span>
      </div>
      <div v-if="!isO2o || isDonate" style="border-top:1px solid; border-top-color:#F0F0F0; margin-top:16px;"></div>
      <div v-if="!isO2o || isDonate" class="check-wrap row agrm-form-input-area" style="display:inline;">
        <DxCheckBox
          style="margin-top:16px;"
          @valueChanged="handleAllAgrm"
        />
      </div>
      <span v-if="!isO2o || isDonate" style= "margin-left:0.5%; font-weight:800;">전체 동의</span>
    </div>
    <TermsPopup />
    <DetailPopup/>
  </section>
</template>

<script>
import { DxCheckBox } from "devextreme-vue/check-box";
import TermsPopup from "./TermsPopup.vue";
import DetailPopup from "./DetailPopup.vue";

export default {
  name: "Terms",
  components: {
    DxCheckBox,
    TermsPopup,
    DetailPopup,
  },
  props: ["ordInfo", "isRegDone","isO2o","isDonate","isEtland"],
  data: () => ({
  	agrms: {
	    allAgrm: false,
	    etlandAgrm:false,
	    allTermAgrm:false,
	    dntnAgrm:false,
	    dntnAgrm2:false,
	    chocAgrm:false
    },
    isShowDetail: true,
  }),
  mounted() {
    this.bindDetailClick();
  },
  computed: {
    isAgreedAll() {
      const requiredCnt = this.getTermsContents.filter(
        (obj) => obj.isRequired
      ).length;
      const agreedCnt = this.getTermsContents.filter(
        (obj) => obj.isActive
      ).length;
      return requiredCnt === agreedCnt;
    },
  },
  created() {},
  mounted() {},
  watch: {
  	agrms: {
      deep: true,
      handler (newVal) {
        this.$emit('aggreAllAgrm', newVal)
      }
    },
  },
  methods: {
  	handleAllAgrm(e) {
  	    if(e.value) {
  	    	this.agrms.allAgrm = true
  			this.agrms.etlandAgrm = true
  			this.agrms.dntnAgrm = true
  			this.agrms.dntnAgrm2 = true
  			this.agrms.chocAgrm = true
  	    } else {
  	    	this.agrms.allAgrm = false
  			this.agrms.etlandAgrm = false
  			this.agrms.dntnAgrm = false
  			this.agrms.dntnAgrm2 = false
  			this.agrms.chocAgrm = false
  	    }
  		
    },
    handleChocAgrm(e) {
    	if(e.value && this.agrms.allTermAgrm) {
  	    	this.agrms.allTermAgrm = true
  	    } else {
  	    	this.agrms.allTermAgrm = false
  	    }
    },
    openDetailPopup(e) {
      this.$modal.show("termsPopup", {
        data: { kkkk: "lllll" },
      });
    },
    detailPopup(obj) {
      this.$modal.show("detailPopup", {
      detailNum: obj.detailNum
    })
    },
  }
}
</script>

<style>
	.re-style .form-section .agrm-form-input-area {
		gap : 2px !important;
	}
	
	.re-style .form-section .font-red {
        justify-content: center;
	    align-items: center;
	    display: flex;
	}
	
</style>



// WEBPACK FOOTER //
// src/views/purchase/sale/components/NewTerms.vue